// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tabs--card {\r\n  height: calc(80vh - 110px);\n}\n.el-tab-pane {\r\n  height: calc(80vh - 110px);\r\n  overflow-y: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
